const translation = {
  title: 'अन्वेषण करें',
  sidebar: {
    discovery: 'खोज',
    chat: 'चैट',
    workspace: 'कार्यक्षेत्र',
    action: {
      pin: 'पिन करें',
      unpin: 'पिन हटाएँ',
      rename: 'नाम बदलें',
      delete: 'हटाएं',
    },
    delete: {
      title: 'ऐप हटाएं',
      content: 'क्या आप वाकई इस ऐप को हटाना चाहते हैं?',
    },
  },
  apps: {
    title: 'डिफ़ी द्वारा ऐप्स का अन्वेषण करें',
    description:
      'इन टेम्प्लेट ऐप्स का तुरंत उपयोग करें या टेम्प्लेट्स के आधार पर अपने स्वयं के ऐप्स को कस्टमाइज़ करें।',
    allCategories: 'अनुशंसित',
  },
  appCard: {
    addToWorkspace: 'कार्यक्षेत्र में जोड़ें',
    customize: 'अनुकूलित करें',
  },
  appCustomize: {
    title: '{{name}} से ऐप बनाएँ',
    subTitle: 'ऐप आइकन और नाम',
    nameRequired: 'ऐप का नाम आवश्यक है',
  },
  category: {
    Assistant: 'सहायक',
    Writing: 'लेखन',
    Translate: 'अनुवाद',
    Programming: 'प्रोग्रामिंग',
    HR: 'मानव संसाधन',
    Workflow: 'कार्यप्रवाह',
    Agent: 'आढ़तिया',
    Entertainment: 'मनोरंजन',
  },
}

export default translation
